import Review from "../../components/Review";
function ReviewPage() {
  return (
    <div>
      <Review />
    </div>
  );
}

export default ReviewPage;
